import * as THREE from 'three';
import identity from '../assets/identity/identity-motion.json';

// Shared by the walkable Gallery and its architectural model. The signed
// panel sits on the rear wall of the archive court, to the portrait's left.
export function createMuseumIdentityPanel(parent) {
  const group = new THREE.Group();
  group.name = 'Henry Wang identity panel';
  group.position.set(17.7, 2.85, -7.06);
  parent.add(group);

  const canvas = document.createElement('canvas');
  canvas.width = 1024;
  canvas.height = 768;
  const context = canvas.getContext('2d');
  let disposed = false;
  const nameFont = `400 ${canvas.height * .13}px "PT Serif", Georgia, serif`;
  function paint() {
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = '#111111';
    // Keep the pair centred and above the panel's midpoint, leaving a generous
    // unprinted lower field behind the floating archive installation.
    const signatureWidth = canvas.width * .56;
    const scale = signatureWidth / 73.744;
    context.save();
    context.translate((canvas.width - signatureWidth) / 2 - scale, canvas.height * .16 - 5 * scale);
    context.scale(scale, scale);
    context.fill(new Path2D(identity.monogram), 'evenodd');
    context.restore();
    context.font = nameFont;
    context.textAlign = 'center';
    context.textBaseline = 'alphabetic';
    context.fillText('Henry Wang', canvas.width / 2, canvas.height * .61);
  }
  paint();

  const texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.anisotropy = 4;
  document.fonts.load(nameFont, 'Henry Wang').then(() => {
    if (disposed) return;
    paint();
    texture.needsUpdate = true;
  }).catch(() => {});
  const backing = new THREE.MeshStandardMaterial({ color: '#ffffff', roughness: 1 });
  const printed = new THREE.MeshStandardMaterial({ color: '#ffffff', map: texture, roughness: 1 });
  const mount = new THREE.Mesh(new THREE.BoxGeometry(5.5, 4.125, .05), backing);
  mount.castShadow = true;
  mount.receiveShadow = true;
  group.add(mount);
  const face = new THREE.Mesh(new THREE.PlaneGeometry(5.5, 4.125), printed);
  face.position.z = .027;
  face.receiveShadow = true;
  group.add(face);

  return {
    group,
    dispose() {
      disposed = true;
      group.removeFromParent();
      mount.geometry.dispose();
      face.geometry.dispose();
      backing.dispose();
      printed.dispose();
      texture.dispose();
    },
  };
}
